import { render, staticRenderFns } from "./KonfirmasiTransfer.vue?vue&type=template&id=3630379b&scoped=true&"
import script from "./KonfirmasiTransfer.vue?vue&type=script&lang=js&"
export * from "./KonfirmasiTransfer.vue?vue&type=script&lang=js&"
import style0 from "./KonfirmasiTransfer.vue?vue&type=style&index=0&id=3630379b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630379b",
  null
  
)

export default component.exports